package com.eladfinish.bible.contest.screens.mikud.usecases

import com.eladfinish.bible.contest.common.ChaptersRepository.Companion.migrateFilename
import com.eladfinish.bible.contest.constants.StringConstants.CHAPTER_NUMBER_REGEX
import com.eladfinish.bible.contest.screens.mikud.MikudRepository

class GetChaptersInMikudAsArrayListUseCase {

    operator fun invoke(mikudStr: String?): List<String> {
        val filenames = mutableListOf<String>()
        if (mikudStr.isNullOrEmpty()) {
            return filenames
        }
        val lines = mikudStr.split("\n")
        for (line in lines) {
            val numberAndBookName = line.substring(1, line.indexOf(MikudRepository.DASH) + 1)
            CHAPTER_NUMBER_REGEX.toRegex().findAll(line).forEach {
                filenames.add("_$numberAndBookName${it.groupValues[1]}.txt")
            }
        }
        return filenames.map { it.migrateFilename() }
    }

}
